import Navigation from "@/components/Navigation";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import OptimizedImage from "@/components/OptimizedImage";

const BodyTreatments = () => {
  const [images, setImages] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBodyImages = async () => {
      try {
        console.log('Fetching body treatment images from Supabase storage...');
        const { data, error } = await supabase
          .storage
          .from('body_images')
          .list();

        if (error) {
          console.error('Error fetching body treatment images:', error);
          return;
        }

        console.log('Successfully fetched body treatment images:', data);

        // Get public URLs for each image
        const imageUrls = await Promise.all(
          data.slice(0, 3).map(async (file) => {
            const { data: { publicUrl } } = supabase
              .storage
              .from('body_images')
              .getPublicUrl(file.name);
            return publicUrl;
          })
        );

        console.log('Generated public URLs for body treatment images:', imageUrls);
        setImages(imageUrls);
      } catch (error) {
        console.error('Unexpected error fetching body treatment images:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBodyImages();
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-24 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-serif mb-8">Body Treatments</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              {loading ? (
                <div className="space-y-4">
                  <div className="w-full h-[400px] bg-gray-200 animate-pulse rounded-lg" />
                  <div className="grid grid-cols-2 gap-4">
                    <div className="w-full h-48 bg-gray-200 animate-pulse rounded-lg" />
                    <div className="w-full h-48 bg-gray-200 animate-pulse rounded-lg" />
                  </div>
                </div>
              ) : (
                <>
                  <OptimizedImage
                    src={images[0] || ''}
                    alt="Body Treatments"
                    className="w-full h-[400px] object-cover rounded-lg shadow-lg"
                  />
                  <div className="grid grid-cols-2 gap-4 mt-4">
                    {images.slice(1, 3).map((image, index) => (
                      <OptimizedImage
                        key={index}
                        src={image}
                        alt={`Treatment ${index + 1}`}
                        className="w-full h-48 object-cover rounded-lg shadow-lg"
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
            <div>
              <p className="text-lg mb-6">
                Transform your body with our advanced body treatments. We offer a range of services designed to contour, tone, and rejuvenate your body for optimal results.
              </p>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold mb-2">Body Contouring</h3>
                  <p>Advanced treatments to sculpt and define your body.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Skin Tightening</h3>
                  <p>Improve skin elasticity and firmness across the body.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Cellulite Reduction</h3>
                  <p>Targeted treatments to reduce the appearance of cellulite.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Wellness Treatments</h3>
                  <p>Holistic approaches to body wellness and rejuvenation.</p>
                </div>
              </div>
              <a
                href="https://na02.patientnow.com/a/EVOLVEDYOU"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-primary text-white px-8 py-3 rounded-full text-lg hover:bg-primary/90 transition-colors mt-8"
              >
                Book Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BodyTreatments;